import { Layer, Point } from "@/types/canvas";

export function findIntersectingLayersWithRectangle(
    layerIds: readonly string[],
    layers: ReadonlyMap<string, Layer>,
    a: Point,
    b: Point,
  ) {
    const rect = {
      x: Math.min(a.x, b.x),
      y: Math.min(a.y, b.y),
      width: Math.abs(a.x - b.x),
      height: Math.abs(a.y - b.y),
    };
  
    const ids = [];
  
    for (const layerId of layerIds) {
      const layer = layers.get(layerId);
  
      if (layer == null) {
        continue;
      }
  
      const { x, y, height, width } = layer;
  
      if (
        rect.x + rect.width > x &&
        rect.x < x + width && 
        rect.y + rect.height > y &&
        rect.y < y + height
      ) {
        ids.push(layerId);
      }
    }
  
    return ids;
  };
  